var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9756 2.00036C11.8157 2.00582 11.6617 2.06229 11.5361 2.1615L4.42969 7.76013C3.52774 8.47094 3 9.55711 3 10.7054V20.2504C3 20.9322 3.5682 21.5004 4.25 21.5004H9.25C9.9318 21.5004 10.5 20.9322 10.5 20.2504V15.2504C10.5 15.1028 10.6025 15.0004 10.75 15.0004H13.25C13.3975 15.0004 13.5 15.1028 13.5 15.2504V20.2504C13.5 20.9322 14.0682 21.5004 14.75 21.5004H19.75C20.4318 21.5004 21 20.9322 21 20.2504V10.7054C21 9.55711 20.4723 8.47094 19.5703 7.76013L12.4639 2.1615C12.3252 2.05193 12.1522 1.99487 11.9756 2.00036ZM12 3.70544L18.6426 8.93884C19.1846 9.36602 19.5 10.0158 19.5 10.7054V20.0004H15V15.2504C15 14.2929 14.2075 13.5004 13.25 13.5004H10.75C9.79252 13.5004 9 14.2929 9 15.2504V20.0004H4.5V10.7054C4.5 10.0158 4.81537 9.36602 5.35742 8.93884L12 3.70544Z",
    stroke: "none"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home-icon.cd490e5f2f0e12de142ff26f5952e2ed.svg";
export { ForwardRef as ReactComponent };